
const MyListPage = () => {
    return(
        <div className="form-container">
        <h2>My List</h2>
        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
        </div>
    )
}

export default MyListPage;